var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n8n-text',{staticClass:"n8n-icon",attrs:{"size":_vm.size,"color":_vm.color,"compact":true}},[_c('font-awesome-icon',{class:_vm.$style[_vm.size],attrs:{"icon":_vm.icon,"spin":_vm.spin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }